import { Injectable } from '@angular/core';

import {
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError,
  ControlValidator,
  FileUploadFileSizeValidatorValue
} from '../../types/validator.types';

@Injectable()
export class FileUploadFileSizeControlValidator extends ControlValidator {
  type = ControlValidatorType.FileSizeOfUpload;
  validateMoment = ControlValidateMoment.Input;
  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');
    const fileList = <Array<any>>this.control[`filesList`];
    if (!fileList || fileList.length === 0) {
      this.error.message = '';
      this.error.success = true;
      return this.error;
    }
    const sizeModel = <FileUploadFileSizeValidatorValue>this.model;
    // è®¾ç½®fileç éªè¯éè¯¯ä¿¡æ¯
    fileList.forEach((file) => {
      let isValid = false;
      const fileSize = file.size / 1024 / 1024;
      if (!isNaN(sizeModel.size)) {
        isValid = fileSize <= sizeModel.size;
      }
      if (!isValid) {
        file[`validatorError`] = new ControlValidatorError(false, `æä»¶å¤§å°ä¸è½è¶è¿ ${sizeModel.size} M`);
      }
    });
    // è®¾ç½®å½åéªè¯å¨çéè¯¯ä¿¡æ¯
    let valid = true;
    fileList.forEach((file) => {
      if (file[`validatorError`] && !file[`validatorError`].success) {
        valid = false;
      }
    });
    if (!valid) {
      this.error.message = '';
      this.error.success = false;
    } else {
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }
}
